<template>
  <router-link v-slot="{ href, navigate, isActive }" custom :to="'/' + view">
    <a
      :id="'nav-' + view"
      :href="href"
      class="snav-item"
      :class="[extraClass, { active: isActive }]"
      :aria-current="isActive ? 'page' : undefined"
      @click="navigate"
    >
      <slot />
    </a>
  </router-link>
</template>

<script setup>
defineProps({
  view: { type: String, required: true },
  extraClass: { type: [String, Object, Array], default: "" },
});
</script>
